var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgExpedia = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 33",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5289 32.1474H6.60447C2.96354 32.1474 0 29.1838 0 25.5288V6.60443C0 2.96354 2.96354 0 6.60447 0H25.5289C29.1838 0 32.1333 2.96354 32.1333 6.60443V25.5288C32.1474 29.1838 29.1838 32.1474 25.5289 32.1474Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81981 25.8963V22.7775C9.81981 22.5235 9.62219 22.3259 9.36823 22.3259H6.24944C5.99542 22.3259 5.79785 22.5235 5.79785 22.7775V25.8963C5.79785 26.1504 5.99542 26.3479 6.24944 26.3479H9.36823C9.62219 26.3479 9.81981 26.1504 9.81981 25.8963Z",
    fill: "#191E3B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3483 23.2143V7.84619C26.3483 6.70304 25.431 5.78577 24.2879 5.78577H8.91981C8.60934 5.78577 8.42591 5.8987 8.22834 6.09624L5.16601 9.18679C4.94022 9.41258 5.09545 9.7513 5.43415 9.7513H19.3346L10.7121 18.3738C10.5568 18.529 10.4863 18.6842 10.4863 18.9383V21.2104C10.4863 21.4784 10.6698 21.6619 10.9378 21.6619H13.2099C13.478 21.6619 13.6333 21.5914 13.7744 21.4361L22.3969 12.8136V26.714C22.3969 27.0527 22.7356 27.208 22.9614 26.9822L26.052 23.9058C26.2354 23.7082 26.3483 23.5247 26.3483 23.2143Z",
    fill: "#191E3B"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExpedia, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/expedia.91a04664.svg";
export { ForwardRef as ReactComponent };